import { Event } from '@/types/event';
import { EventsDataResult } from './eventsDataShared';
import { UseEventsQueryOptions, useEventsQuery } from './useEventsQuery';
import { useInfiniteList } from './useInfiniteList';

export type UseEventsDataOptions = UseEventsQueryOptions;

const getEventId = (event: Event) => event.id;

export function useEventsData(
    options: UseEventsDataOptions,
): EventsDataResult<Event> {
    const { cacheKey, pageStateKey, fetchPage } = useEventsQuery(options);
    return useInfiniteList<Event>({
        cacheKey,
        pageStateKey,
        fetchPage,
        getId: getEventId,
    });
}
